import React from 'react'
import { ChatResponse } from "../components/message-components/chat-response.component";
import ChatBotApiService from '../services/chatbot-api.service';
import GlobalStoreService from "../services/global-store.service";
import { globalConstants } from "../constants/globalConstants";
import UtilService from "../services/util.service";
import PlatformType from '../enums/PlatformType';
import { SCRIPTS } from '../constants/staticScripts';
import ScenarioType from '../enums/scenario-type';

export default class ActionsCommonService {

    static handleCreateSr = (params) => {
        const { data, resolve, reject } = params;
        const result = data;
        if (result.dffStepResponse) {
            delete result.dffStepResponse;
        }
        const chatItem = {
            response: (data && data.response) ? data.response : "",
            options: (data && data.scenario && data.scenario.scenarioStep && data.scenario.scenarioStep.options) ? data.scenario.scenarioStep.options : [],
            scenarioActive: data.scenarioActive,
            type: "chatbot",
            sentTime: UtilService.getCurrentTime(),
            scenarioResponse: (data) ? data : ""
        };

        ChatBotApiService.submitDffCall(data.aditionalData.reqData).then(
            response => {
                try {
                    const apiResponse = response;


                    const messageList = {};
                    let message_objects = [];
                    messageList.leapText = (data && data.aditionalData && data.aditionalData.leapText) ?
                        data.aditionalData.leapText :
                        "";
                    if (response && response.status && response.status === "UNAUTHORIZED") {
                        //HANDLING SESSION EXPIRATION
                        chatItem.response = globalConstants.SESSION_EXPIRED_STATUS.message;

                        message_objects.push({
                            component_type: 'DEFAULT',
                            message: chatItem.response,
                            messageTime: chatItem.sentTime
                        })
                        resolve({
                            message_objects,
                            scenarioResponse: result
                        });

                    } else if (apiResponse &&
                        apiResponse.result &&
                        apiResponse.result.message
                    ) {

                        messageList.response = (data && data.response) ?
                            data.response :
                            "";

                        messageList.statusMessage = (GlobalStoreService.get("APP_CONTEXT") &&
                            apiResponse.result.message.indexOf("Click") !== -1) ?
                            `${apiResponse.result.message.substring(
                                0,
                                apiResponse.result.message.indexOf("Click") - 1
                            )}` :
                            `${apiResponse.result.message}`;

                        if (messageList && messageList.leapText) {
                            const splittedChatItem = JSON.parse(JSON.stringify(chatItem));
                            splittedChatItem.response = messageList.leapText;
                            // console.log('leap text message',messageList.leapText)
                            message_objects.push({
                                component_type: 'DEFAULT',
                                message: splittedChatItem.response,
                                messageTime: splittedChatItem.sentTime
                            })

                        }
                        // if(messageList && messageList.response){
                        //     const splittedChatItem = JSON.parse(JSON.stringify(chatItem));
                        //     splittedChatItem.response = messageList.response;
                        // }
                        if (messageList && messageList.statusMessage) {
                            // console.log('status message',messageList.statusMessage)
                            const splittedChatItem = JSON.parse(JSON.stringify(chatItem));
                            splittedChatItem.response = messageList.statusMessage;

                            message_objects.push({
                                component_type: 'DEFAULT',
                                message: splittedChatItem.response,
                                messageTime: splittedChatItem.sentTime
                            })

                        }
                        resolve({
                            message_objects,
                            scenarioResponse: result
                        });

                    } else if (apiResponse.statusCode === "CRM_CONSUME_SR_API_ERROR") {

                        messageList.statusMessage = (GlobalStoreService.get("APP_CONTEXT") &&
                            apiResponse.result.message.indexOf("Click") !== -1) ?
                            `${apiResponse.result.message.substring(0,
                                apiResponse.result.message.indexOf("Click") - 1)}` :
                            `${apiResponse.result.message}`;

                        if (messageList && messageList.leapText) {
                            const splittedChatItem = JSON.parse(JSON.stringify(chatItem));
                            splittedChatItem.response = messageList.leapText;
                            //TO DO VERIFY
                            message_objects.push({
                                component_type: 'DEFAULT',
                                message: splittedChatItem.response,
                                messageTime: splittedChatItem.sentTime
                            })

                        }
                        if (messageList && messageList.statusMessage) {
                            const splittedChatItem = JSON.parse(JSON.stringify(chatItem));
                            splittedChatItem.response = messageList.statusMessage;

                            message_objects.push({
                                component_type: 'DEFAULT',
                                message: splittedChatItem.response,
                                messageTime: splittedChatItem.sentTime
                            })

                        }
                        resolve({
                            message_objects,
                            scenarioResponse: result
                        });

                    } else if (apiResponse.statusCode === "PROCESSING_EXCEPTION") {
                        // HANDLE ERROR CONDITION  ( SR NOT RAISED)
                        // chatItem.response = `${apiResponse.statusMessage}`;

                        chatItem.response = globalConstants.error.genericSRError;
                        message_objects.push({
                            component_type: 'DEFAULT',
                            message: chatItem.response,
                            messageTime: chatItem.sentTime
                        })
                        resolve({
                            message_objects,
                            scenarioResponse: result
                        });
                    } 
                    else if(apiResponse &&
                        apiResponse.result &&
                        apiResponse.result.tagId && !apiResponse.result.message){

                            message_objects.push({
                                component_type: 'DEFAULT',
                                message: SCRIPTS.SR_RAISED_SUCCESSFULLY + apiResponse.result.tagId + '.',
                                messageTime: UtilService.getCurrentTime()
                            })
                            resolve({
                                message_objects,
                                scenarioResponse: result
                            });
                    }
                    else {
                        chatItem.response = `${messageList.leapText}`;
                        message_objects.push({
                            component_type: 'DEFAULT',
                            message: chatItem.response,
                            messageTime: chatItem.sentTime
                        })
                        resolve({
                            message_objects,
                            scenarioResponse: result
                        });
                    }




                } catch (exception) {
                    // HANDLE EXCEPTION
                    reject({ status: exception });
                }
            },
            (error) => {
                // HANDLE ERROR
                // REMOVE
                // reject({status: error});
                let message_objects = []
                chatItem["response"] = globalConstants.dffSubmitErrorMsg;
                message_objects.push({
                    component_type: 'DEFAULT',
                    message: chatItem.response,
                    messageTime: chatItem.sentTime
                })
                resolve({
                    message_objects,
                    scenarioResponse: result
                });
            }
        );
    }

    static getWebOrAppSpecificResponse = (response) => {
        let data = "";
        if (response.indexOf("mobilecontentstart") !== -1) {
            const platformType = GlobalStoreService.get("platformType");
            if (platformType === PlatformType.IOS || platformType === PlatformType.ANDROID) {
                if (
                    response.split("<div><b>mobilecontentstart</b></div>")[1]
                ) {
                    data = response
                        .split("<div><b>mobilecontentstart</b></div>")[1]
                        .split("<div><b>mobilecontentend</b></div>")[0];
                } else {
                    data = response.substring(
                        0,
                        response.indexOf("mobilecontentstart") - 8
                    );
                }
            } else {
                data = response.substring(
                    0,
                    response.indexOf("mobilecontentstart") - 8
                );
            }
        } else {
            data = response;
        }
        return data;
    }
    static getPlatformSpeciifcDescription = (result, strategy) => {
        const platformType = GlobalStoreService.get("platformType");
        let finalResult = result;
        if (strategy === "DTScenario" || !strategy) {
            const list = new DOMParser().parseFromString(result, "text/html");
            const allAnchorTags = list.body.querySelectorAll("a");
            for (let i = 0; i < allAnchorTags.length; i += 1) {
                const originalHref = allAnchorTags[i].href.replace(/%7C/g, "|");
                const splittedAllHrefValues = originalHref.split("|");
                if (splittedAllHrefValues.length > 1) {
                    if (platformType === PlatformType.IOS) {
                        finalResult = finalResult.replace(
                            originalHref,
                            splittedAllHrefValues[1]
                        );
                    } else if (platformType === PlatformType.ANDROID) {
                        if (GlobalStoreService.get("APP_CONTEXT")) {
                            finalResult = finalResult.replace(
                                originalHref,
                                splittedAllHrefValues[2]
                            );
                        } else {
                            finalResult = finalResult.replace(
                                originalHref,
                                splittedAllHrefValues[0]
                            );
                        }
                    } else {
                        finalResult = finalResult.replace(
                            originalHref,
                            splittedAllHrefValues[0]
                        );
                    }
                }
            }
            const replaceString = "{mobile}";
            finalResult = UtilService.replaceAll(
                finalResult,
                replaceString,
                GlobalStoreService.get("currentNumber") ? GlobalStoreService.get("currentNumber") : ""
            );
            return finalResult;
        } else if (strategy === ScenarioType.FAQScenario && result.searchReply) {
            //
           return ActionsCommonService.getPlatformSpecificSearchReply(result)
        }
        else {
            return SCRIPTS.DEFAULT_ERROR
        }
    };


    static getPlatformSpecificSearchReply = (result)=>{

        const platformType = GlobalStoreService.get("platformType");
        let finalResult = result;

        if (platformType === PlatformType.ANDROID) {
            if (GlobalStoreService.get("APP_CONTEXT") && result.searchReply.android) {
                const replaceString = "{mobile}";
                finalResult = UtilService.replaceAll(
                    result.searchReply.android,
                    replaceString,
                    GlobalStoreService.get("currentNumber")
                );
                return finalResult;
            } else if (!GlobalStoreService.get("APP_CONTEXT") && result.searchReply.web) {
                const replaceString = "{mobile}";
                finalResult = UtilService.replaceAll(
                    result.searchReply.web,
                    replaceString,
                    GlobalStoreService.get("currentNumber")
                );
                return finalResult;
            }
            else {
                return SCRIPTS.DEFAULT_ERROR
            }
        } else if (platformType === PlatformType.IOS) {
            if (GlobalStoreService.get("APP_CONTEXT") && result.searchReply.ios) {
                const replaceString = "{mobile}";
                finalResult = UtilService.replaceAll(
                    result.searchReply.ios,
                    replaceString,
                    GlobalStoreService.get("currentNumber")
                );
                return finalResult;
            }
            else if (!GlobalStoreService.get("APP_CONTEXT") && result.searchReply.web) {
                const replaceString = "{mobile}";
                finalResult = UtilService.replaceAll(
                    result.searchReply.web,
                    replaceString,
                    GlobalStoreService.get("currentNumber")
                );
                return finalResult;
            }
            else {
                return SCRIPTS.DEFAULT_ERROR
            }

        }
        return result.searchReply.web;
    }

    static getLinkDataForChoice = (enteredText, result) => {
        const ScenarioObject = result.scenario;
        if (
            ScenarioObject &&
            ScenarioObject["scenarioStep"] &&
            ScenarioObject["scenarioStep"]["options"] &&
            ScenarioObject["scenarioStep"]["options"].length
        ) {
            for (
                let i = 0;
                i < ScenarioObject["scenarioStep"]["options"].length;
                i++
            ) {
                if (
                    ScenarioObject["scenarioStep"]["options"][i]["displayText"].toUpperCase() ===
                    enteredText.toUpperCase() &&
                    ScenarioObject["scenarioStep"]["options"][i]["stepLink"]
                ) {
                    return ScenarioObject["scenarioStep"]["options"][i][
                        "stepLink"
                    ];
                }
            }
        }
        return null;
    };


    static getBookmarkedScenarioIdForChoice = (enteredText, result) => {
        const ScenarioObject = result.scenario;
        if (
            ScenarioObject &&
            ScenarioObject["scenarioStep"] &&
            ScenarioObject["scenarioStep"]["options"] &&
            ScenarioObject["scenarioStep"]["options"].length
        ) {
            for (
                let i = 0;
                i < ScenarioObject["scenarioStep"]["options"].length;
                i++
            ) {
                if (
                    ScenarioObject["scenarioStep"]["options"][i]["displayText"].toUpperCase() ===
                    enteredText.toUpperCase() &&
                    ScenarioObject["scenarioStep"]["options"][i]["bookMark"] &&
                    ScenarioObject["scenarioStep"]["options"][i]["bookMark"][
                    "scenarioId"
                    ]
                ) {
                    return ScenarioObject["scenarioStep"]["options"][i][
                        "bookMark"
                    ];
                }
            }
        }
        return null;
    };

    static handleCrmConsumeSrApiError = (result, resolve, reject) => {
        // console.log('handleCrmConsumeSrApiError')
        const chatItem = {
            response: (result && result.response) ? result.response : "",
            options: (result && result.scenario && result.scenario.scenarioStep && result.scenario.scenarioStep.options) ? result.scenario.scenarioStep.options : [],
            scenarioActive: result.scenarioActive,
            type: "chatbot",
            sentTime: UtilService.getCurrentTime(),
            scenarioResponse: (result) ? result : ""
        };

        let response = {};
        let message_objects = []
        response.leapText = (result.additionalInfo && result.additionalInfo.leap_informCustomerScript) ?
            result.additionalInfo.leap_informCustomerScript :
            "";

        response.status = (GlobalStoreService.get("APP_CONTEXT") && result.dffStepResponse.statusMessage.indexOf("Click") !== -1) ?
            `${result.dffStepResponse.statusMessage.substring(0, result.dffStepResponse.statusMessage.indexOf("Click") - 1)}` :
            result.dffStepResponse.statusMessage;

        chatItem.response = `${response.leapText} ${response.status}`;

        message_objects.push({
            component_type: 'DEFAULT',
            message: chatItem.response,
            messageTime: chatItem.sentTime
        })

        resolve({
            message_objects,
            scenarioResponse: result
        });
    }

    static handleDffForm = (result, resolve, reject) => {
        const DFFFields = result.dffStepResponse.result;
        // console.log('handle dff')
        // PREPARING FIELD LIST
        let DFFFieldToBeDisplayed = [];
        for (let i = 0; i < DFFFields.length; i += 1) {
            // if (
            //     DFFFields[i].name !== "Customer Lat/Long" &&
            //     DFFFields[i].name !==
            //     "Problem Address & Landmark (M)" &&
            //     DFFFields[i].name !== "Problem Address(M)"
            // ) {
            //     DFFFieldToBeDisplayed.push(DFFFields[i]);
            // }
            if (DFFFields[i].name === "Alternate number" ||
                DFFFields[i].name === "Alt contact number" ||
                DFFFields[i].name === "Alt contact number(M)" ||
                DFFFields[i].name === "Alternate Contact Number(M)" ||
                DFFFields[i].name === "Alternate Contact Number" ||
                DFFFields[i].name === "Alternate Landline Number" ||
                DFFFields[i].name === "Alternate Number(M)" ||
                DFFFields[i].name === "Enter Alternate Number") {
                DFFFieldToBeDisplayed.push(DFFFields[i]);
            }
        }

        // REMOVE 
        // DFFFieldToBeDisplayed.push({
        //     order: "1",
        //     value: "NA",
        //     name: "ALternate Numbers"
        // });

        // SETTING LEAP INFO
        const additionalInfo = {};
        additionalInfo.leapText = (result.additionalInfo && result.additionalInfo.leap_informCustomerScript) ?
            result.additionalInfo.leap_informCustomerScript : "";

        // SETTING LEAP ADDRESS 
        additionalInfo.leap_address = (result.additionalInfo && result.additionalInfo.leap_address) ? result.additionalInfo.leap_address : "";

        // SETTING LAT LONG
        additionalInfo.lat_long = (result.additionalInfo && result.additionalInfo.leap_latitude && result.additionalInfo.leap_longitude) ?
            `${result.additionalInfo.leap_latitude},${result.additionalInfo.leap_longitude}` : "";

        // SETTING CRM CODE
        additionalInfo.crmCode = result.crmCode;
        const chatItem = {
            response: (result && result.response) ? result.response : "",
            options: (result && result.scenario && result.scenario.scenarioStep && result.scenario.scenarioStep.options) ? result.scenario.scenarioStep.options : [],
            scenarioActive: result.scenarioActive,
            type: "chatbot",
            sentTime: UtilService.getCurrentTime(),
            scenarioResponse: (result) ? result : ""
        };

        // let component_arr = [];
        let message_objects = []
        // TO DO ------ component added showing dff response 


        if (result.response && !UtilService.isResponseEmpty(result.response)) {

            let dffResChatItem = chatItem;
            message_objects.push({
                component_type: 'DEFAULT',
                message: result.response,
                messageTime: UtilService.getCurrentTime()
            })
        }
        chatItem.response = globalConstants.script.dffShowText;
        if (chatItem.response && DFFFieldToBeDisplayed && DFFFieldToBeDisplayed.length > 0) {

            message_objects.push({
                component_type: 'DEFAULT',
                message: chatItem.response,
                messageTime: chatItem.sentTime,
                notToBeWrittenToDB: true
            })
        }
        let bottom_comp
        if (DFFFieldToBeDisplayed && DFFFieldToBeDisplayed.length > 0) {
            bottom_comp = { type: globalConstants.BOTTOM_BAR_COMPONENTS.DFF_FORM_COMPONENT, dff_form_obj: { chatItem, DFFFieldToBeDisplayed, additionalInfo } }
        }

        resolve(
            {
                message_objects,
                scenarioResponse: result,
                bottom_comp: bottom_comp
            }
        );
    }
    static showDffResponse = (result, resolve, reject) => {
        // console.log('show dff res')
        const chatItem = {
            response: (result && result.response) ? result.response : "",
            options: (result && result.scenario && result.scenario.scenarioStep && result.scenario.scenarioStep.options) ? result.scenario.scenarioStep.options : [],
            scenarioActive: result.scenarioActive,
            type: "chatbot",
            sentTime: UtilService.getCurrentTime(),
            scenarioResponse: (result) ? result : ""
        }
        let message_objects = []
        chatItem.response = (GlobalStoreService.get("APP_CONTEXT") && result.dffStepResponse.result.message.indexOf("Click") !== -1) ?
            `${result.dffStepResponse.result.message.substring(
                0,
                result.dffStepResponse.result.message.indexOf("Click") - 1
            )}` :
            result.dffStepResponse.result.message;

        message_objects.push({
            component_type: 'DEFAULT',
            message: chatItem.response,
            messageTime: chatItem.sentTime
        })

        resolve({
            message_objects,
            scenarioResponse: result
        });
    }

}


// WEBPACK FOOTER //
// ./src/services/actions-common.service.js